var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,on:{"click":_vm.onClick}},[_c('span',{staticClass:"open"},[_vm._v(_vm._s(_vm.openName))]),_vm._v(" "),_c('span',{staticClass:"close"},[_vm._v(_vm._s(_vm.closeName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39ac88b9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-switch/switch-2.vue
// module id = 2164
// module chunks = 0